/** Cross-layout knowledge-bank upload (Home hint ↔ edit modals). */
export const OPEN_KB_UPLOAD_EVENT = "plambo:open-kb-upload";
export const KB_UPLOADED_EVENT = "plambo:kb-uploaded";

/**
 * Ask Header to open the edit client/project modal on the Assets step.
 * @param {{ projectId?: string|number|null }} [detail]
 */
export function dispatchOpenKbUpload({ projectId = null } = {}) {
  window.dispatchEvent(
    new CustomEvent(OPEN_KB_UPLOAD_EVENT, {
      detail: { projectId: projectId ?? null },
    }),
  );
}

export function dispatchKbUploaded({ projectId = null } = {}) {
  window.dispatchEvent(
    new CustomEvent(KB_UPLOADED_EVENT, {
      detail: { projectId: projectId ?? null },
    }),
  );
}
